import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class HeaderStatsBannerModel {
    imageUrl = new EditableFieldModel('banner_url', FieldType.image, '/assets/hero-banner/esp_banner.jpg');
    videoUrl = new EditableFieldModel('video_url', FieldType.video, '');
    buttonText = new EditableFieldModel('action_button_text', FieldType.text, 'Play with me');
    buttonLink = new EditableFieldModel('navigate_to_product', FieldType.products, '/');
    nickname = new EditableFieldModel('nickname', FieldType.text, 'Nickname');

    location = new EditableFieldModel('location', FieldType.countries, 'Russian', null, [
        {
            key: 'locationCode',
            value: 'ru',
        }
    ])
    contact = new EditableFieldModel('contact', FieldType.nested, new ContactModel());
    stats = new EditableFieldModel('stats', FieldType.array, [
        new StatsModel({label: 'Stat 1', value: '10'}),
        new StatsModel({label: 'Stat 2', value: '10'}),
        new StatsModel({label: 'Stat 3', value: '10'}),
        new StatsModel({label: 'Stat 4',value:  '10'})
    ], StatsModel);

    fieldsMap = [
        this.imageUrl,
        this.videoUrl,
        this.buttonText,
        this.buttonLink,
        this.nickname,
        this.location,
        this.contact,
        this.stats
    ];


    constructor(data?: {imageUrl?: any,
                videoUrl?: any,
                buttonText?: any,
                buttonLink?: any,
                nickname?: any,
                location?: any,
                locationCode?: any,
                contact?: any,
                stats?: any}) {
        if(data?.imageUrl){
            this.imageUrl.value = data.imageUrl.value;
        }
        if(data?.videoUrl){
            this.videoUrl.value = data.videoUrl.value;
        }
        if(data?.buttonText){
            this.buttonText.value = data.buttonText.value;
        }
        if(data?.buttonLink){
            this.buttonLink.value = data.buttonLink.value;
        }
        if(data?.nickname){
            this.nickname.value = data.nickname.value;
        }
        if(data?.location){
            this.location.value = data.location.value;
            this.location.options = data.location.options;
        }
        if(data?.contact){
            this.contact.value = new ContactModel(data?.contact?.value);
        }
        if(data?.stats){
            this.stats.value = [];
            for(let key in data?.stats.value){
                this.stats.value.push(new StatsModel({label: data?.stats.value[key].label.value, value: data?.stats.value[key].value.value}));
            }
        }
    }
}

export class StatsModel {
    label =  new EditableFieldModel('title_of_stat', FieldType.text, 'Stats');
    value = new EditableFieldModel('value_of_stat', FieldType.text, '1')

    fieldsMap = [this.label, this.value];

    constructor(data?: {label?: string, value?: string}) {
        if(data?.label){
            this.label.value = data.label;
        }
        if (data?.value) {
            this.value.value = data.value;
        }
    }

}

export class ContactModel {
    twitter = new EditableFieldModel('twitter', FieldType.link, '');
    website = new EditableFieldModel('website', FieldType.link, '/');
    youtube = new EditableFieldModel('youtube', FieldType.link, '');
    facebook = new EditableFieldModel('facebook', FieldType.link, '');
    instagram = new EditableFieldModel('instagram', FieldType.link, '');
    telegram = new EditableFieldModel('telegram', FieldType.link, '');
    discord = new EditableFieldModel('discord', FieldType.link, '');
    tiktok = new EditableFieldModel('tiktok', FieldType.link, '');
    twitch = new EditableFieldModel('twitch', FieldType.link, '');
    vk = new EditableFieldModel('vk', FieldType.link, '');
    fieldsMap = [
        this.twitter,
        this.website,
        this.youtube,
        this.facebook,
        this.instagram,
        this.telegram,
        this.discord,
        this.tiktok,
        this.twitch,
        this.vk
    ];
    constructor(data?: {twitter?: any,
                website?: any,
                youtube?: any,
                facebook?: any,
                instagram?: any,
                telegram?: any,
                discord?: any,
                tiktok?: any,
                vk?: any,
                twitch?: any}) {
        if(data?.tiktok?.value){
            this.tiktok.value = data.tiktok.value;
        }
        if(data?.twitter?.value){
            this.twitter.value = data.twitter.value;
        }
        if(data?.youtube?.value){
            this.youtube.value = data.youtube.value;
        }
        if(data?.facebook?.value){
            this.facebook.value = data.facebook.value;
        }
        if(data?.website?.value){
            this.website.value = data.website.value;
        }
        if(data?.instagram?.value){
            this.instagram.value = data.instagram.value;
        }
        if(data?.telegram?.value){
            this.telegram.value = data.telegram.value;
        }
        if(data?.discord?.value){
            this.discord.value = data.discord.value;
        }
        if(data?.twitch?.value){
            this.twitch.value = data.twitch.value;
        }
        if(data?.vk?.value){
            this.vk.value = data.vk.value;
        }
    }
}